var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTestimonialTip = function SvgTestimonialTip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H11.3871C9.91935 6.29354 9.70968 10.5871 16 15.954C16 15.954 10.8282 16.4098 7.19355 14.4513C3.20968 12.3045 3 6.93757 3 6.93757V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V0C16 8.83656 8.83656 16 0 16V16V0Z",
    fill: "white"
  })));
};

export { SvgTestimonialTip as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgMkgxMS4zODcxQzkuOTE5MzUgNi4yOTM1NCA5LjcwOTY4IDEwLjU4NzEgMTYgMTUuOTU0QzE2IDE1Ljk1NCAxMC44MjgyIDE2LjQwOTggNy4xOTM1NSAxNC40NTEzQzMuMjA5NjggMTIuMzA0NSAzIDYuOTM3NTcgMyA2LjkzNzU3VjJaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMCAwSDE2VjBDMTYgOC44MzY1NiA4LjgzNjU2IDE2IDAgMTZWMTZWMFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";